<template>
	<div class="success-component">
		<div class="success w1200">
			<div class="back">&lt;返回</div>
			<div class="infobox">
				<div class="title">企业注册已成功提交</div>
				<div class="tips">如果超时未审核，可通过平台企业微信/客服电话等方式进行处理</div>
				<img src="@/assets/img/003.png" alt />
				<div class="msg">
					客服会在1-3个工作日内加急审核，期间会有客服核
					<br />
					实注册信息，请留意接听139-0002-0002的来电
				</div>
			</div>
			<div class="btns">
				<router-link :to="{ name: 'home' }">
					<el-button class="login-btn" type="primary">进入首页({{ threeNum }}秒)</el-button>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				threeNum: 3,
			}
		},
		mounted() {
			let timer = setInterval(() => {
				this.threeNum--
				if (this.threeNum == 0) {
				    clearInterval(timer);
				    this.$router.push({ name: "home" })
				  }
			},1000)
		}
	}
</script>

<style lang="scss" scoped>
.success {
	text-align: center;
	img {
		display: inline-block;
	}
	.back {
		font-size: 16px;
		height: 68px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.title {
		margin: 130px 0 12px;
		font-size: 22px;
		font-weight: 600;
		color: var(--color-text-1);
		text-align: center;
		line-height: 30px;
	}
	.tips {
		font-size: 13px;
		line-height: 18px;
		color: var(--color-text-4);
		margin-bottom: 80px;
	}
	.msg {
		margin-top: 30px;
		color: rgb(var(--primary-6));
		font-weight: 500;
		margin-bottom: 190px;
		font-size: 16px;
		line-height: 22px;
	}
	.btns {
		margin: 44px auto;
	}
}
</style>
